import React from 'react';
import { Flex } from 'rebass';
import { graphql } from "gatsby";
import Image from "../image";
import { pathOr, path } from "ramda";
import Markup from "../markup";
import BorderWrapper from "../borderWrapper";
import HeadingTransparent from "../headingTransparent";
import Audio from "../audio";
import Container from "./container";
import { blurredConfig, descriptionConfig } from "../posed";
import useSlidePose from "../../hooks/useSlidePose";
import posed from "react-pose";
import { useGetFieldsByName } from "../../utils";
import { useColorMode } from "theme-ui";

const PosedHeadingTransparent = posed(HeadingTransparent)(blurredConfig);
const PosedMarkup = posed(Markup)(descriptionConfig);
const PosedAudio = posed(Audio)(descriptionConfig);

const ModuleEdito = ({ module, state, index }) => {
	const image = pathOr(null, ['relationships', 'image', 'relationships', 'file', 'localFile', 'childImageSharp', 'fluid'], module);
	const pose = useSlidePose(state, index);
	const audio = pathOr(null, ['relationships', 'audio', 'relationships', 'file', 'localFile', 'publicURL'], module);
	const [colorMode] = useColorMode();
	const { description, title } = useGetFieldsByName(['title', 'description'], module, colorMode);

	return (
		<BorderWrapper
			flexDirection={['column', null, 'row']}
			alignItems={['stretch', null, 'flex-start']}
		>
			{image ? <Image
				width={['100%', null, 0.45]}
				height={[null, null, '100%']}
				sx={{ flexShrink: [null, null, 0] }}
				fluid={image} /> : null}
			<Flex sx={{ flexGrow: [null, null, 0] }} height={[null, null, "100%"]} bg="bg" alignItems="center" justifyContent="center">
				<Container justifyContent={[null, null, "flex-end"]}>
					<Flex
						width={[null, null, 0.5]}
						flexDirection="column"
						alignItems="center"
						justifyContent="center"
					>
						<PosedHeadingTransparent pose={pose} image={path(['base64'], image)} textAlign="left"  width="100%" fontSize={[36, null, 8, 10]} mb={4}>{title}</PosedHeadingTransparent>
						<PosedMarkup pose={pose} html={description && description.processed} fontSize={1} height="auto" px={[null, null, 5]}/>
						{audio && <PosedAudio pose={pose} mt={[4, null, 3]} color={path(['fields', 'palette'], module)} src={audio}/>}
					</Flex>
				</Container>
			</Flex>
		</BorderWrapper>
	)
};

export default ModuleEdito;

export const query = graphql`
    fragment moduleEditoFragment on paragraph__module_edito {
        internal {
            type
        }
        title: field_title
        description: field_description {
            processed
        }
        title_dark: field_dark_titre
        description_dark: field_dark_description {
            processed
        }
        fields {
            palette
        }
        relationships {
            audio: field_audio {
                relationships {
                    file: field_media_audio_file {
                        localFile {
                            publicURL
                        }
                    }
                }
            }
            image: field_image {
                relationships {
                    file: field_media_image {
                        localFile {
                            childImageSharp {
                                fluid(maxWidth: 960, quality: 80) {
                                    ...GatsbyImageSharpFluid_withWebp
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;